export default {
  items: [
    // {
    //   name: 'Dashboard',
    //   url: '/dashboard',
    //   icon: 'icon-speedometer'
    // },
    {
      title: true,
      name: 'Promotion',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    // {
    //   name: 'Users',
    //   url: '/promotion_users',
    //   icon: 'icon-user'
    // },
    {
      name: 'Applications',
      url: '/applications',
      icon: 'icon-pencil'
    },
    {
      name: 'Logout',
      url: '/logout',
      icon: 'icon-pencil'
    },
  ]
}
